module.exports = __webpack_public_path__ + "img/pattern.077456c9.svg";